import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { PlannerConfigEntity } from '@/services/configurator/PlannerConfigTypes';
import { formattedDate } from '@/utils/date';
import { PARAMS } from '@/utils/params';
import { DialogDescription } from '@radix-ui/react-dialog';
import { TriangleAlert } from 'lucide-react';
import { Link } from 'react-router-dom';

export function DraftsModal(props: {
  identifier: string;
  openDialog: boolean;
  setOpenDialog: (open: boolean) => void;
  drafts: PlannerConfigEntity[];
  showExtendedInfo?: boolean;
}) {
  return (
    <Dialog
      open={props.openDialog}
      onOpenChange={(open) => {
        props.setOpenDialog(open);
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Do you want to continue with your draft?</DialogTitle>
          <DialogDescription className='flex items-center italic'>
            <TriangleAlert className='fill-orange-500 text-white' /> Your
            changes will be discarded
          </DialogDescription>
        </DialogHeader>
        <div className='grid gap-4 px-1 py-4 pe-4 max-h-96 overflow-y-scroll'>
          {props.drafts.map((item, index) => {
            return (
              <Link
                to={`/planner/draft?${PARAMS.FROM_DRAFT_ID}=${item.id}`}
                onClick={() => {
                  props.setOpenDialog(false);
                }}
                className='w-auto h-auto justify-start px-4 py-2 rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 border-primary'
                key={`${item.id}-${index}`}
              >
                <div className='flex flex-col items-start'>
                  <p>Planner: {item.identifier}</p>
                  <p>Last modified: {formattedDate(item.lastModified)}</p>
                  {props.showExtendedInfo ? (
                    <p>Modified by: {item.modifiedBy}</p>
                  ) : null}
                </div>
              </Link>
            );
          })}
        </div>
        <DialogFooter className='sm:justify-end'>
          <Link
            to={`/planner/draft?${PARAMS.FROM_IDENTIFIER}=${props.identifier}`}
            onClick={() => {
              props.setOpenDialog(false);
            }}
            className='w-auto h-auto justify-start px-4 py-2 rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 border-primary'
            key={`${props.identifier}`}
          >
            No, I want to start a new draft
          </Link>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
